
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class App extends Vue {
  created() {
    if (document.getElementById("loading-mask")) document.getElementById("loading-mask").remove();
  }
}
